export const IS_UPGRADABLE_ACCOUNT = 'FETCH_IS_UPGRADABLE_ACCOUNT';
export const IS_RENEWABLE_ACCOUNT = 'FETCH_IS_RENEWABLE_ACCOUNT';
export const IS_EVALUATION_ALLOWED = 'FETCH_IS_EVALUATION_ALLOWED';
export const CUSTOMER_ACCOUNT_OVERVIEWS_ASYNC = 'FETCH_CUSTOMER_ACCOUNT_OVERVIEWS_ASYNC';
export const DETAILS = 'mac/FETCH_DETAILS';
export const ADD_CONTACT = 'ADD_CONTACT';
export const MAKE_CONTACT_PRIMARY = 'MAKE_CONTACT_PRIMARY';
export const MAKE_CONTACT_PRIMARY_NOTIFICATION = 'MAKE_CONTACT_PRIMARY_NOTIFICATION';
export const VALIDATE_CONTACT = 'VALIDATE_CONTACT';
export const END_USER_CSV_DOWNLOAD_RESULT = 'END_USER_CSV_DOWNLOAD_RESULT';
export const END_USER_CSV_DOWNLOAD_IN_PROGRESS = 'END_USER_CSV_DOWNLOAD_IN_PROGRESS';
export const END_USER_CSV_DOWNLOAD_IS_MIGRATION_IN_PROGRESS =
  'END_USER_CSV_DOWNLOAD_IS_MIGRATION_IN_PROGRESS';
export const GET_APP_PARENT_SEN = 'GET_APP_PARENT_SEN';
export const POST_APP_PARENT_SEN = 'POST_APP_PARENT_SEN';
export const CLEAR_APP_PARENT_SEN_ERROR = 'CLEAR_APP_PARENT_SEN_ERROR';
